import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging, isSupported } from 'firebase/messaging';
import { hasWebPushCapabilities } from '../utils/webPushCapabilities';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const isFirebaseMessagingConfigured = () =>
  Boolean(
    firebaseConfig.projectId?.trim() &&
      firebaseConfig.messagingSenderId?.trim() &&
      firebaseConfig.appId?.trim() &&
      firebaseConfig.apiKey?.trim(),
  );

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export { app };

let messagingInstancePromise = null;

export const resetFirebaseMessagingCache = () => {
  messagingInstancePromise = null;
};

export const getFirebaseMessaging = async ({ forceRefresh = false } = {}) => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (forceRefresh) {
    messagingInstancePromise = null;
  }

  if (messagingInstancePromise) {
    return messagingInstancePromise;
  }

  messagingInstancePromise = (async () => {
    const supported = await isSupported();
    if (!supported && !hasWebPushCapabilities()) {
      return null;
    }

    try {
      // Firebase: onMessage requires firebase-messaging-sw.js to be registered first.
      // https://firebase.google.com/docs/cloud-messaging/web/receive-messages
      const { registerMessagingServiceWorker } = await import('../services/fcmWebRegistration');
      await registerMessagingServiceWorker();
      return getMessaging(app);
    } catch (error) {
      console.warn('[FCM] getMessaging failed:', error);
      return null;
    }
  })();

  return messagingInstancePromise;
};
